import React from 'react';

import { useTranslation } from 'react-i18next';

import { useNode } from '@craftjs/core';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const displayOptions = [
  {
    key: 'inline-block',
    value: 'inline-block',
    label: 'inline_block',
  },
  { key: 'block', value: 'block', label: 'block' },
  { key: 'inline', value: 'inline', label: 'inline' },
];

const DisplayStyle = ({ sx = {} }) => {
  const { t } = useTranslation();
  const {
    actions: { setProp },
    display,
  } = useNode(({ data: { props } }) => {
    return {
      display: props.display,
    };
  });

  const onDisplayChange = (event) => {
    setProp((props) => {
      props.display = event.target.value;
    }, 500);
  };

  return (
    <FormControl fullWidth sx={{ maxWidth: '200px', ...sx }}>
      <InputLabel id='demo-simple-select-label'>{t('display')}</InputLabel>
      <Select
        labelId='demo-simple-select-label'
        id='demo-simple-select'
        value={display}
        label={t('display')}
        onChange={onDisplayChange}
        size='small'
      >
        {displayOptions.map((item) => (
          <MenuItem value={item.value} size='small'>
            {t(item.label)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DisplayStyle;
